var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.303,
    height: 84,
    viewBox: "0 0 59.303 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5558b2324a0429a69e8ea0fcfe6403aa",
    "data-name": "5558b2324a0429a69e8ea0fcfe6403aa",
    transform: "translate(-8.85 0.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M36.1,45.359l-3.674.088a3.145,3.145,0,0,1-3.222-3.084l-.188-8.8,9.967-.251.188,8.826A3.166,3.166,0,0,1,36.1,45.359Z",
    transform: "translate(5.118 8.706)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M37.609,33.335l-4.952,7.071a3.148,3.148,0,0,0,2.658,4.952h0a3.15,3.15,0,0,0,3.072-3.222L38.2,33.31h-.589Z",
    transform: "translate(5.895 8.706)",
    fill: "#374047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M53.325,36.85A22.382,22.382,0,1,1,52.61,5.205,22.382,22.382,0,0,1,53.325,36.85Z",
    transform: "translate(1.5 0)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M51.258,3.98,20.24,36.252a.234.234,0,0,1,.038.05A22.377,22.377,0,0,0,51.245,3.993Z",
    transform: "translate(2.89 1.263)",
    fill: "#374047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M48.367,32.058a17.026,17.026,0,1,1-.539-24.072A17.019,17.019,0,0,1,48.367,32.058Z",
    transform: "translate(2.584 1.081)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M46.8,7.06,23.2,31.609l.038.038A17.021,17.021,0,0,0,46.8,7.073Z",
    transform: "translate(3.641 2.045)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1.956,0H12.763a1.958,1.958,0,0,1,1.956,1.956V24.3a7.3,7.3,0,0,1-7.3,7.3H7.3A7.3,7.3,0,0,1,0,24.3V1.956A1.958,1.958,0,0,1,1.956,0Z",
    transform: "translate(31.759 50.865) rotate(-1.28)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M41.906,64.864a7.464,7.464,0,0,1-7.2,7.7,7.3,7.3,0,0,1-5.68-2.545,5.034,5.034,0,0,0,.614.025,7.448,7.448,0,0,0,7.2-7.7l-.489-22.129,3.022-.075a1.99,1.99,0,0,1,2.019,1.968l.514,22.756Z",
    transform: "translate(5.121 10.439)",
    fill: "#374047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M14.06,1.959a.543.543,0,0,1,.3-.326c.238-.113.451-.05.451,0s-.188.05-.389.15S14.1,2,14.06,1.971Z",
    transform: "translate(1.322 0.651)",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(8.85 16.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M14.492,13.21H68.153V27.1H14.492A5.65,5.65,0,0,1,8.85,21.46V18.852A5.65,5.65,0,0,1,14.492,13.21Z",
    transform: "translate(-8.85 -13.21)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 28.047,
    height: 13.892,
    transform: "translate(31.256)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M17.84,19.24a2.42,2.42,0,1,1-2.42-2.42A2.413,2.413,0,0,1,17.84,19.24Z",
    transform: "translate(-7.797 -12.294)",
    fill: "#485460"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.924,
    cy: 3.924,
    r: 3.924,
    transform: "translate(21.088 3.022)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3.924,
    cy: 3.924,
    r: 3.924,
    transform: "translate(33.826 3.022)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M28.8,15.61v7.861a3.924,3.924,0,1,0,0-7.849Z",
    transform: "translate(-3.787 -12.601)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M38.96,15.61v7.861a3.924,3.924,0,1,0,0-7.849Z",
    transform: "translate(-1.209 -12.601)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M14.93,16.82v4.84a2.42,2.42,0,1,0,0-4.84Z",
    transform: "translate(-7.307 -12.294)",
    fill: "#494f54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.98c74a5857dc1761b329c98953978433.svg";
export { ForwardRef as ReactComponent };